module.exports = "/images/blister-6.png";